"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Document = void 0;
var _mui = require("@ori-ui/mui");
var _api = require("../../models/api");
var _Loading = require("../Loading");
var _DocumentContent = require("./DocumentContent");
var _DocumentHeader = require("./DocumentHeader");
var _DocumentStyledComponents = require("./DocumentStyledComponents");
var _jsxRuntime = require("react/jsx-runtime");
const Document = props => {
  const {
    documentIds,
    documentTypeId,
    isDeleteConfirmationRequired,
    editableDocument,
    name,
    config,
    isRequired,
    documentLabel,
    documentInfoText,
    handleDocumentsChange
  } = props;
  const {
    data: documentsTypeData
  } = (0, _api.useDocumentTypes)();
  const {
    data: documentsInfoData
  } = (0, _api.useCustomerDocumentsInfos)();
  const getTypeById = documentTypeIdProperty => documentsTypeData?.find(type => type.documentTypeId === documentTypeIdProperty);
  const isLoading = !documentsTypeData || !documentsInfoData;
  const documentType = getTypeById(documentTypeId);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DocumentStyledComponents.RootContainer, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentHeader.DocumentHeader, {
      label: documentLabel,
      requiredDocument: Boolean(isRequired)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      paragraph: true,
      variant: "body1",
      align: "left",
      children: documentInfoText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentContent.DocumentContent, {
      documentInpuName: name,
      documentIsRequired: Boolean(isRequired),
      documentTypeId: documentTypeId,
      documentType: documentType,
      documentIds: documentIds,
      handleDocumentsChange: handleDocumentsChange,
      editableDocument: editableDocument,
      deleteConfirmationRequired: isDeleteConfirmationRequired,
      configDocument: config
    }), isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {}) : null]
  });
};
exports.Document = Document;